module.exports = __webpack_public_path__ + "static/12ccaff8f935dda5c9303a727d99141ef53da8e4ae33c67e7ffba668bc3cc856-1e7c8af716f52ce5119c24e4501820b6.png";